import {Injectable} from '@angular/core';
import {SubmittedResponses} from "../../models";

@Injectable()
export class StoreService {

    // configResponse : ConfigResponse;             // received from config.json
    // pollResponse : PollResponse;                 // received from poll.json
    // questionsResponse : QuestionsResponse;       // received from start.json, questions.json
    private submittedResponses: SubmittedResponses;     // object passed to submit.json
    //takerResultsResponse: TakerResultsResponse; // received from final submit.json
    //pollResultsResponse: PollResultsResponse;   // received from results.json

    // getPoll() : PollResponse {
    //     return this.pollResponse;
    // }
    //
    // getConfig() : ConfigResponse {
    //     return this.configResponse;
    // }
    //
    // getQuestions() : QuestionsResponse {
    //     return this.questionsResponse;
    // }
    //
    getSubmittedResponses(): SubmittedResponses {
        return this.submittedResponses;
    }

    setSubmittedResponses(submittedResponses: SubmittedResponses) {
        this.submittedResponses = submittedResponses;
    }
}
